import { useLocation } from 'react-router-dom'
import qs from 'qs'
import { useCallback, useEffect, useState } from 'react'
import { API } from 'constants/apiEndPoints'
import { config } from 'config/index'
import axios from 'axios'
import { useUser } from 'hooks/user/useUser'
import { RedditLinkCSS } from './RedditLinkCSS.styled'
import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { useIntervalWhen } from 'utils/hooks/useIntervalWhen'
import ms from 'ms.macro'

const { YOLO_BASE_URL } = config

export const RedditLink = () => {
  const { search } = useLocation()
  const { accessToken } = useUser('wallet')
  const { code } = qs.parse(search, { ignoreQueryPrefix: true })
  const [response, setResponse] = useState()
  const [state, setState] = useState('pending')

  const callAPI = useCallback(async () => {
    await axios
      .post(
        API.ACCOUNT_REDDIT_CONNECT,
        { code, redirectUri: `${YOLO_BASE_URL}/game/reddit/link` },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((response) => {
        setResponse(response)
        setState('success')
      })
      .catch((error) => {
        setState('error')
      })
  })

  useIntervalWhen(
    () => {
      window.close()
    },
    ms`4s`,
    state === 'success',
    false
  )

  useEffect(() => {
    if (code && accessToken) callAPI()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, accessToken])
  console.log('ACZ: state', { state })
  return (
    <RedditLinkCSS>
      <div className='reddit_to_yolorekt'>
        <ContentSwitcherByState
          noWrapper
          activeState={state}
          stateObject={{
            pending: (
              <>
                <h1>Connecting...</h1>
                <h2>Please wait</h2>
              </>
            ),
            success: (
              <>
                <h1>Success!</h1>
                <h2>Now taking you back to YOLOREKT ...</h2>
              </>
            ),
            error: (
              <>
                <h1>Error</h1>
                <h2>Is the account already linked?</h2>
              </>
            ),
          }}
        />
        <div className='logos_connect'>
          <div className='reddit_icon'></div>
          <div className='connect_icon'>
            <ContentSwitcherByState
              noWrapper
              activeState={state}
              stateObject={{
                default: (
                  <SingleDataLoader
                    loading={state === 'pending'}
                    data={<div className='linked ' />}
                  />
                ),
                error: <div className='error' />,
              }}
            />
          </div>
          <div className='yolorekt_icon'></div>
        </div>
      </div>
    </RedditLinkCSS>
  )
}
